import { createFileRoute } from "@tanstack/react-router";
import { Black2x1Page } from "@/components/black2x1/Black2x1Page";
import heroBlack from "@/assets/black2x1/hero-black2x1-identity.webp";

const URL = "https://fisioemortopedia.com.br/black-oferta-entregas";

export const Route = createFileRoute("/black-oferta-entregas")({
  head: () => ({
    meta: [
      { title: "BLACK EM DOBRO · Oferta e material | FEO" },
      { name: "description", content: "BLACK EM DOBRO da FEO: duas pós-graduações pelo preço de uma. Oferta disponível até 4 de novembro de 2026, às 01h00 de Brasília." },
      { name: "robots", content: "noindex,nofollow" },
      { property: "og:title", content: "BLACK EM DOBRO · Oferta e material | FEO" },
      { property: "og:description", content: "Duas pós-graduações pelo preço de uma. Oferta disponível até 4 de novembro, às 01h00 de Brasília." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "BLACK EM DOBRO · Oferta e material | FEO" },
      { name: "twitter:description", content: "Duas pós-graduações pelo preço de uma. Oferta disponível até 4 de novembro, às 01h00 de Brasília." },
    ],
    links: [
      { rel: "canonical", href: URL },
      { rel: "preload", as: "image", href: heroBlack, fetchPriority: "high" as const },
    ],
  }),
  component: () => <Black2x1Page mode="oferta" variant="oferta-entregas" />,
});
